export default __webpack_public_path__ + "static/media/Haval.9fc6200f.jpg";